import React from 'react';

const Spin2Win = () => (
	<div className="spin2win">
		<div className="double-bounce1"></div>
		<div className="double-bounce2"></div>
	</div>
);

export default Spin2Win;



// WEBPACK FOOTER //
// ./components/Spin2Win.js